import { request } from "@/interface/helper";

const str = "communityReport";

export const communityReport = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/report/list" }),
    detail: data => request({ data, method: "post", url: "/community/report/detail" }),
    edit: data => request({ data, method: "post", url: "/community/report/modify" })
  }
};
